/* @ngInject */ export function RunTag(BooksData, SERVER) {
  BooksData.Tag = function (t) {
    var tag = Object.assign(Object.create(BooksData.Tag.prototype), t || {});

    return tag;
  };

  BooksData.Tag.prototype = {
    id: NaN,
    organizationID: NaN,
    type: NaN,
    indicator: null,
    description: null,
    showAssigned: true,
    showNotAssigned: false,
    allowManual: false,
    assignedAfterDate: null,
    assignedBeforeDate: null,

    /** Type flags. */
    get isIndicator() {
      return this.type == SERVER.BooksDBConstants.TT_INDICATOR;
    },
    get isLifetime() {
      return this.type == SERVER.BooksDBConstants.TT_LIFETIME_MEMBERSHIP;
    },
    get isMembership() {
      return this.type == SERVER.BooksDBConstants.TT_MEMBERSHIP;
    },
    get isStatus() {
      return this.type == SERVER.BooksDBConstants.TT_STATUS;
    },

    /** Label function for the `Display When` grid column. Returns a string to be 
      displayed based on the assigned/not assigned properties on the tag. */
    get displayCondition() {
      return this.showAssigned && this.showNotAssigned
        ? 'Both'
        : this.showAssigned
          ? 'Assigned'
          : this.showNotAssigned
            ? 'Not Assigned'
            : 'Not Displayed';
    }
  };
}